import type { OnboardingBusinessProfile, OnboardingState, OnboardingStepDefinition } from './types';

export const EMPTY_BUSINESS_PROFILE: OnboardingBusinessProfile = {
  whatYouDo: '',
  whyChooseYou: '',
  productDetails: '',
  leadSourcesAndGoal: '',
  commonQuestionsAndAnswers: '',
};

export const DEFAULT_ONBOARDING_STATE: OnboardingState = {
  currentStep: 1,
  completedSteps: [],
  isComplete: false,
  completedAt: null,
  completedByUserId: null,
  lastSavedAt: null,
};

export const REQUIRED_SCRIPT_CATEGORIES = ['Hook', 'Key Questions', 'Qualification'] as const;

export const ONBOARDING_STEP_LABELS = [
  'הורדה',
  'התאמה אישית',
  'פרופיל עסקי',
  'יצירת תסריט',
  'טיפול בהתנגדויות',
] as const;

export const ONBOARDING_TOTAL_STEPS = ONBOARDING_STEP_LABELS.length;

export const DASHBOARD_TOUR_FORCE_START_KEY = 'dashboard-tour-force-start';
export const DASHBOARD_TOUR_FORCE_START_EVENT = 'dashboard-tour-force-start';
export const ONBOARDING_BACK_FROM_DASHBOARD_TOUR_EVENT = 'onboarding-back-from-dashboard-tour';
export const LIVE_SETUP_TOUR_FORCE_START_KEY = 'live-setup-tour-force-start';
export const LIVE_SETUP_TOUR_START_EVENT = 'live-setup-tour-start';
export const SCRIPT_SETUP_FORCE_START_KEY = 'script-setup-force-start';
export const SCRIPT_SETUP_START_EVENT = 'script-setup-start';
export const SCRIPT_SETUP_REOPEN_CELEBRATION_EVENT = 'script-setup-reopen-celebration';
export const CHECKLIST_GUIDE_FORCE_START_KEY = 'checklist-guide-force-start';
export const CHECKLIST_GUIDE_START_EVENT = 'checklist-guide-start';

export const ONBOARDING_STEPS: OnboardingStepDefinition[] = [
  {
    step: 1,
    eyebrow: 'Step 1',
    title: ONBOARDING_STEP_LABELS[0],
    description: 'Install the local service, verify the connection, and confirm this machine is ready.',
  },
  {
    step: 2,
    eyebrow: 'Step 2',
    title: ONBOARDING_STEP_LABELS[1],
    description: 'Capture the business context question-by-question and let the AI build the first playbook.',
  },
  {
    step: 3,
    eyebrow: 'Step 3',
    title: ONBOARDING_STEP_LABELS[2],
    description: 'The AI synthesizes everything you shared into a sharp business description used in every call.',
  },
  {
    step: 4,
    eyebrow: 'Step 4',
    title: ONBOARDING_STEP_LABELS[3],
    description: 'Build the call script that guides reps and powers AI analysis.',
  },
  {
    step: 5,
    eyebrow: 'Step 5',
    title: ONBOARDING_STEP_LABELS[4],
    description: 'Configure how the AI responds to the most common customer objections.',
  },
];
